import { ACTION_BLOCK_TYPES } from '@pes-ui/utils';
export const MAX_TOP_CATEGORIES = 12;
export const ACTION_BLOCK_GROUPS = {
  PRIMARY: [ACTION_BLOCK_TYPES.PRODUCTS_FROM_A_TO_Z, ACTION_BLOCK_TYPES.PRODUCT_SELECTOR_LIST],
  ALT_PRIMARY: [ACTION_BLOCK_TYPES.DOWNLOAD_CENTER],
  SECONDARY: [ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT, ACTION_BLOCK_TYPES.DOWNLOAD_CENTER],
  ALT_SECONDARY: [],
};
export const gridWithOneActionBlock = {
  6: [0, 1, 2, 3, 4, 5],
  7: [0, 1, 2, 3, 6],
  8: [0, 3, 4, 7],
  9: [0, 5, 8],
  10: [0, 9],
  11: [0],
};
export const gridWithTwoActionBlocks = {
  8: [0, 1, 2, 3],
  9: [0, 5, 7],
  10: [0, 8],
  11: [0],
};
